import React, { PureComponent } from 'react';

import { FileEditor as ConnectFileEditor } from '@atlassian/bitbucket-connect-react';
import { ConnectFileEditorProps } from '@atlassian/bitbucket-connect-react/src/components/fileEditor';

import { commitFileTarget } from 'src/connect/targets';

import LoadingFailed from './loading-failed';

/**
 * Connect module keys follow the following pattern:
 *
 * KEY_PATTERN = r'^[a-zA-Z0-9-_\.]+$'
 *
 * The value below will never be registered as a "real" module, so we can safely
 * use it to distinguish between a missing key (the default behavior when toggling
 * edit mode for a file -- automatically detect and choose a Connect module, or
 * fall back to our default editor) vs. forcing the default to be enabled
 */
export const DEFAULT_EDITOR_KEY = '$default';

export interface Props extends ConnectFileEditorProps {
  hash?: string;
  height?: string;
  path: string;
  repositoryFullSlug?: string;
}

export default class FileEditor extends PureComponent<Props> {
  render() {
    const {
      source,
      hash,
      height,
      path,
      principalId,
      repositoryFullSlug,
      ...otherProps
    } = this.props;

    if (!principalId || !repositoryFullSlug || !hash) {
      return null;
    }

    const [repositoryOwner, repositorySlug] = repositoryFullSlug.split('/');

    const query = [
      {
        target: commitFileTarget({
          path,
          hash,
          repositoryOwner,
          repositorySlug,
        }),
        modules: [
          {
            moduleType: 'fileEditors',
          },
          {
            moduleType: 'generalPages',
          },
        ],
      },
    ];

    return (
      <ConnectFileEditor
        {...otherProps}
        defaultStyles={{
          display: 'block',
          height,
        }}
        loadingFailedComponent={LoadingFailed}
        principalId={principalId}
        source={source}
        query={query}
      />
    );
  }
}
